/*
 * @Name 商旅酒店排队订单Store
 */
import services from '../../services/index'

const state = {
    imported: '',
    notImport: ''
}

const mutations = {

    /**
     * 订单房间使用过情况
     */
    setOrderChckinImportStateMut(state, payload) {
        state.imported = payload.imported
        state.notImport = payload.notImport
    }
}

const actions = {

    /** 查询巴展id */
    getBrazilExhiIDAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.getBrazilExhiIDSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 查询展会下全部商旅订单
    getAllTravelHotelOrderAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.getAllTravelHotelOrderSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 全量商旅酒店订单导出
     */
    exportFullOrder(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.exportFullOrder(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 查询订单列表[预定+排队订单]
     */
    getTravelHotelOrderAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.getTravelHotelOrderSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 查询订单酒店的房型列表（排队）
     */
    getTravelHotelOrderRoomListAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.getTravelHotelOrderRoomListSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 查询订单酒店的房型列表（预订）
     */
    getTravelHotelOrderQueuingRoomListAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.getTravelHotelOrderQueuingRoomListSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 查询订单酒店的详细基本信息
     */
    getTravelHotelOrderDetiltAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.getTravelHotelOrderDetilSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 查询商旅酒店订单导入名单
     */
    getTravelHotelOrderImportCheckinAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.getTravelHotelOrderImportCheckinSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 导入锁
     */
    importLockAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.importLockSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 撤销订单导入名单
     */
    cancelRoomStayMemberSerAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.cancelRoomStayMemberSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 商旅酒店房间导入入住名单情况
     */
    getOrderCheckinImportStateAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.getOrderCheckinImportStateSer(param).then((res) => {
                context.commit('setOrderChckinImportStateMut', res.data.data)
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 商旅酒店房间导入酒店列表查询接口
     */
    findHotelPageListByOrderIdAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.findHotelPageListByOrderIdSer(param).then((res) => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 查询酒店下所有房型下拉数据
     */
    findHotelRoomPageListAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.findHotelRoomPageListSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 查询订单下所有地区部的数据
     */
    findAreaPageListAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.findAreaPageListSer(param).then((res) => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 版本数据
     */
    findBusinessOrderVersionInfoAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.findBusinessOrderVersionInfoSer(param).then((res) => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 版本数据对比数据
     */
    findBusinessOrderVersionComparisonAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.findBusinessOrderVersionComparisonSer(param).then((res) => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 删除订单
     */
    deleteSingleAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.deleteSingleSer(param).then((res) => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 加锁服务
     */
    findRoomStayMemberLockAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.findRoomStayMemberLockSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 解锁服务
     */
    findroomStayMemberUnLockAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.findroomStayMemberUnLockSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 商旅酒店房间使用情况查询
     */
    getOrderRoomUseSituationAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.getOrderRoomUseSituationSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 商旅酒店订单取消订单
     */
    cancelBusinessOrderAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.cancelBusinessOrderSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 商旅酒店订单取消校验
     */
    checkBusinessHotelNoShowFeeAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.checkBusinessHotelNoShowFeeSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 商旅酒店排队订单发送通知
     */
    updateBusinessOrderStutesAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.updateBusinessOrderStutesSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 商旅入住名单导出
     */
    orderCheckInExportAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.orderCheckInExportSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 商旅入住名单校验
     */
    validEditParamAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.validEditParamSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 商旅入住名单保存
     */
    memberAce(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.memberSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 商旅酒店使用情况导出
     */
    roomUseStatisticsExportAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.roomUseStatisticsExportSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 商旅入住名单导入
     */
    orderCheckInImportAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.orderCheckInImportSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 商旅酒店详情查询房型下入住人员清单
     */
    findBusinessOrderMemberDetailByIdAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.findBusinessOrderMemberDetailByIdSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    // 查询商旅预订统计数据
    getBusinessOrderCountAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.getBusinessOrderCountSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    // 商旅预订统计导出
    exportBusinessOrderCountAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.exportBusinessOrderCountSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    // 商旅根据酒店ID房型ID日期范围查询实际入住量
    getRelUseInfoAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.getRelUseInfoSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    // 商旅订单。 录入与更新实际酒店房型实际入住量 POST
    batchCreateUpdateAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.batchCreateUpdateSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    // 商旅预订统计导出客户 get
    exportHotelAllStayMemberAct(context, param) {
        return new Promise((resolve, reject) => {
            services.travelHotelOrderSer.exportHotelAllStayMemberSer(param).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
